import { Controller } from "@hotwired/stimulus"

// Shows a loading skeleton in the chat content area on first navigation
// to a chat. Revisits use Turbo's page cache for instant display.
export default class extends Controller {
  static targets = ["content", "skeleton"]

  initialize() {
    this.visited = new Set()
  }

  connect() {
    document.addEventListener("turbo:click", this.handleClick)
  }

  disconnect() {
    document.removeEventListener("turbo:click", this.handleClick)
  }

  handleClick = (event) => {
    const link = event.target.closest("a")
    if (!link) return
    const href = link.getAttribute("href") || ""
    if (!href.match(/\/chats\/\d/)) return
    if (this.visited.has(href)) return
    this.visited.add(href)

    if (this.hasContentTarget && this.hasSkeletonTarget) {
      this.contentTarget.innerHTML = this.skeletonTarget.innerHTML
    }
  }
}
